module.exports = __webpack_public_path__ + "src/assets/img/ferra.2ca6d6d9.jpg";